import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { Booking, getBookingsSingle } from "api/bookings";
import i18n from "./i18n";
import SIPFormDialog from "../BookingsView/SIPFormDialog";

// prop types
interface EmbeddedSIPFormViewProps {
    urlData: { [x: string]: string },
    onAuthorizeExternal: (token: string) => void,
}

// embedded sip form view for mobile app
const EmbeddedSIPFormView = ({ urlData, onAuthorizeExternal }: EmbeddedSIPFormViewProps) => {
    // snackbar
    const { enqueueSnackbar } = useSnackbar();
    const displayError = (error: any) => enqueueSnackbar(
        `${i18n.anErrorOccurred}: ${error?.description} (${error?.type})`,
        { variant: "error" },
    );

    // ui state
    const [booking, setBooking] = useState<Booking>();

    // fetch data
    const fetchBooking = async () => {
        try {
            onAuthorizeExternal(urlData.token);
            setBooking(await getBookingsSingle({ bookingId: urlData.bookingId }));
        } catch (error) {
            displayError(error);
        }
    };
    useEffect(() => { fetchBooking(); }, [urlData]);

    // render
    return (
        <SIPFormDialog
            booking={booking}
            show={!!booking}
            onClose={() => window.ReactNativeWebView?.postMessage("close")}
        />
    );
};

export default EmbeddedSIPFormView;
